import { extendTheme } from '@mui/joy';

const theme = extendTheme({
  colorSchemes: {
    light: {
      palette: {
        background: {
          surface: '#F7F6F8',
        },
        grey1: '#F7F6F8', // Light grey
        grey2: '#E4E3E8', // Medium light grey
        grey3: '#CECCD6', // Medium grey
        grey4: '#928FA3', // Dark grey
        grey5: '#5C5A66', // Dark grey
        bluePrimary: '#2257F6', // Blue primary
        blueSecondary: '#3766F6', // Blue secondary (hover)
        blueLight: '#E9EEFE', // Blue light
        blueFlash: '#73FBFD', // Flash blue
        blueDark: '#131367', // Dark blue
        green1: '#1FAD37', // Green 1
        green2: '#65D879', // Green 2
        green3: '#E8F9EB', // Green 3
        orange1: '#ED6C2D', // Orange 1
        orange2: '#F2986C', // Orange 2
        orange3: '#FDE8DE', // Orange 3
        white: '#FFFFFF',
        black: '#242339',
        red: {
          500: '#FF9292',
          300: '#FFE8E8',
        },
        green: {
          500: '#65D879',
          600: '#1FAD37',
        },
        blue: {
          400: '#3766F6',
        },
        yellow: {
          500: '#FFD366',
        },
      },
    },
  },
  breakpoints: {
    values: {
      tooSmall: 0,
      mobile: 320,
      tablet: 600,
      intermediateNavbar: 854,
      intermediateHome: 1024,
      desktop: 1080,
      bigDesktop: 1600,
    },
  },
  fontFamily: {
    body: 'Roboto',
    display: 'Roboto',
  },
  fontSize: {
    xs: '10px',
    sm: '12px',
    md: '14px',
    lg: '16px',
    xl: '18px',
    xl2: '24px',
  },
  lineHeight: {
    sm: '18px',
    md: '1.1',
    lg: '1.2',
    xl: '1.25',
  },
  fontWeight: {
    sm: 400,
    md: 500,
    lg: 600,
    xl: 700,
  },
  typography: {
    'navbar-title': {
      fontFamily: 'var(--joy-fontFamily-display)',
      fontSize: '24px',
      fontWeight: 700,
      lineHeight: '28px',
      color: 'var(--joy-palette-black)',
    },
    'light-title': {
      fontFamily: 'var(--joy-fontFamily-display)',
      fontSize: '24px',
      fontWeight: 400,
      lineHeight: '28px',
      color: 'var(--joy-palette-black)',
    },
    'section-title': {
      fontFamily: 'var(--joy-fontFamily-display)',
      fontSize: '18px',
      fontWeight: 500,
      lineHeight: '21px',
      color: 'var(--joy-palette-black)',
    },
    'body-regular': {
      fontFamily: 'var(--joy-fontFamily-display)',
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '20px',
      color: 'var(--joy-palette-black)',
    },
    'body-md': {
      fontFamily: 'var(--joy-fontFamily-display)',
      fontSize: '16px',
      fontWeight: 500,
      lineHeight: '20px',
      color: 'var(--joy-palette-black)',
    },
    'body-bold': {
      fontFamily: 'var(--joy-fontFamily-display)',
      fontSize: '16px',
      fontWeight: 700,
      lineHeight: '20px',
      color: 'var(--joy-palette-black)',
    },
    'body-small': {
      fontFamily: 'var(--joy-fontFamily-display)',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '18px',
      color: 'var(--joy-palette-black)',
    },
    'small-medium': {
      fontFamily: 'var(--joy-fontFamily-display)',
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: '18px',
      color: 'var(--joy-palette-black)',
    },
    'legend-regular': {
      fontFamily: 'var(--joy-fontFamily-display)',
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '14px',
      color: 'var(--joy-palette-black)',
    },
    'legend-medium': {
      fontFamily: 'var(--joy-fontFamily-display)',
      fontSize: '12px',
      fontWeight: 500,
      lineHeight: '14px',
      color: 'var(--joy-palette-black)',
    },
  },
});

export default theme;

declare module '@mui/joy/styles' {
  interface Palette {
    grey1: string;
    grey2: string;
    grey3: string;
    grey4: string;
    grey5: string;
    bluePrimary: string;
    blueSecondary: string;
    blueLight: string;
    blueFlash: string;
    blueDark: string;
    green1: string;
    green2: string;
    green3: string;
    orange1: string;
    orange2: string;
    orange3: string;
    white: string;
    black: string;
    red: {
      500: string;
      300: string;
    };
    green: {
      500: string;
      600: string;
    };
    blue: {
      400: string;
    };
    yellow: {
      500: string;
    };
  }
  interface BreakpointOverrides {
    xxs: false;
    xs: false;
    sm: false;
    md: false;
    lg: false;
    xl: false;
    tooSmall: true;
    mobile: true;
    tablet: true;
    intermediateNavbar: true;
    intermediateHome: true;
    desktop: true;
    bigDesktop: true;
  }
  interface TypographySystemOverrides {
    'navbar-title': true;
    'light-title': true;
    'section-title': true;
    'body-regular': true;
    'body-md': true;
    'body-bold': true;
    'body-small': true;
    'small-medium': true;
    'legend-regular': true;
    'legend-medium': true;
  }
}
